import { Badge } from "reactstrap";
import "./LiveIndicator.css";

const LiveIndicator = ({ 
  size = "small", 
  pulseColor = "#ff4444", 
  text = "Live",
  showPulse = true,
}) => {
  const sizeStyles = {
    tiny: { dotSize: 6, fontSize: "0.7rem", padding: "1px 6px", gap: "4px" },
    small: { dotSize: 6, fontSize: "0.75rem", padding: "2px 8px", gap: "5px" },
    medium: { dotSize: 8, fontSize: "0.8rem", padding: "3px 10px", gap: "6px" }
  };

  const currentSize = sizeStyles[size] || sizeStyles.small;

  const handleMouseEnter = (e) => {
    e.currentTarget.style.backgroundColor = "rgba(255, 68, 68, 0.12)";
    e.currentTarget.style.transform = "scale(1.02)";
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.backgroundColor = "rgba(255, 68, 68, 0.08)";
    e.currentTarget.style.transform = "scale(1)";
  };

  return (
    <div 
      className={`live-indicator-compact size-${size}`}
      style={{
        padding: currentSize.padding,
        fontSize: currentSize.fontSize,
        gap: currentSize.gap,
        '--pulse-color': pulseColor,
        '--dot-size': `${currentSize.dotSize}px`
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="live-dot-container">
        <div className="live-dot-main"></div>
        {showPulse && <div className="live-dot-pulse"></div>}
      </div>
      <span className="live-text-compact">
        {text}
      </span>
    </div>
  );
};

export const CompactLiveIndicator = ({ variant = "default", showText = true }) => {
  const variants = {
    default: { color: "#d63031" },
    success: { color: "#27ae60" },
    warning: { color: "#f39c12" },
    purple: { color: "#9b59b6" },
    blue: { color: "#3498db" }
  };

  const currentVariant = variants[variant] || variants.default;

  return (
    <Badge
      className={`compact-live-badge variant-${variant}`}
      style={{
        '--variant-color': currentVariant.color
      }}
      pill
    >
      <span className="compact-dot"></span>
      {showText && "LIVE"}
    </Badge>
  );
};

// Ultra minimal dot-only version
export const LiveDot = ({ color = "#ff4444", size = "small", pulse = true }) => {
  return (
    <div 
      className={`live-dot-only ${pulse ? 'pulse' : ''} size-${size}`}
      style={{ '--dot-color': color }}
      title="Live on Web"
    />
  );
};

export default LiveIndicator;